import { photoConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const savePhoto = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressPhoto.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':photoId', form.id) :
            url.recipientProgressPhotos.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: photoConstants.SAVING_PHOTO_REQUEST }),
        success: (data) => ({ type: photoConstants.SAVING_PHOTO_SUCCESS, data }),
        failure: (error) => ({ type: photoConstants.SAVING_PHOTO_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved photo.' }
        }
    }
});

export const deletePhoto = ({ recipientId, progressId, photoId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressPhoto.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':photoId', photoId),
        method: 'DELETE',
        request: () => ({ type: photoConstants.DELETE_PHOTO_REQUEST }),
        success: (data) => ({ type: photoConstants.DELETE_PHOTO_SUCCESS, data }),
        failure: (error) => ({ type: photoConstants.DELETE_PHOTO_FAILURE, error }),
        formatData: () => (photoId),
        progress: {
            request: { message: () => 'Deleting photo' },
            success: { message: () => 'Deleted photo.' }
        }
    }
});

export const loadPhotos = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressPhotos.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: photoConstants.LOAD_PHOTOS_REQUEST }),
        success: (data) => ({ type: photoConstants.LOAD_PHOTOS_SUCCESS, data }),
        failure: (error) => ({ type: photoConstants.LOAD_PHOTOS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/photo.actions.js